export default "__VITE_ASSET__DvmU8eSF__"